import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { debounce } from 'lodash';  // Using lodash for debouncing
import { TextField, InputAdornment, CircularProgress, Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';  // MUI search icon

const SearchGmail = ({ setSearchGmail }) => {
    const [query, setQuery] = useState('');  // Search query
    const [loading, setLoading] = useState(false);
    const [noResults, setNoResults] = useState(false);

    const limit = 100;  // Number of items per page

    // Function to fetch accounts based on search query and pagination
    const fetchGmail = async (searchQuery, page) => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}gmail/search`, {
                params: {
                    query: searchQuery,
                    page: page,
                    limit: limit
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setSearchGmail(response.data);

            if (response.data.gmails.length === 0) {
                setNoResults(true);
            } else {
                setNoResults(false);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching accounts:', error);
            setLoading(false);
        }
    };


    const debouncedSearch = useCallback(debounce((searchQuery) => {
        if (searchQuery) {  
            fetchGmail(searchQuery, 1);  
        }
    }, 500), []);

    useEffect(() => {
        if (query) {
            debouncedSearch(query);
        }
    }, [query, debouncedSearch]);

    const handlePageChange = (newPage) => {
        fetchGmail(query, newPage);
    };

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', mb: 2, gap: 2 }}>
            {/* Search Input */}
            <TextField
                variant="outlined"
                label="Search by Gmail , Recovery Email"
                value={query}
                onChange={(e) => setQuery(e.target.value)}  // Update query state
                sx={{
                    width: '400px',

                    // backgroundColor: 'white',  // White background
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#e0e0e0', // Light gray border color
                        },
                        '&:hover fieldset': {
                            borderColor: '#bdbdbd', // Darker gray on hover
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#9e9e9e', // Darkest gray when focused
                        },
                    },
                    '& .MuiInputBase-input': {
                        color: 'white',  // Black text color
                    },
                    '& .MuiInputLabel-root': {
                        color: '#757575',  // Gray label color
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: '#616161',  // Dark gray label when focused
                    }
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <SearchIcon sx={{ color: 'white' }} />
                        </InputAdornment>
                    )
                }}
            />

            {/* Loading Indicator */}
            {loading && (
                <CircularProgress />
            )}

            {!loading && noResults &&
                <p>No results found</p>
            }
        </Box>
    );
};

export default SearchGmail;

